import { createSlice } from "@reduxjs/toolkit";

// isLoggedIn used to default to false and flip to true only after App.js's
// useEffect decoded the token - but ProtectedRouteAuth/Login also fire on
// that same first render, and their effects run before App.js's has a
// chance to dispatch, so they'd hard-redirect to foresyts.ai even when a
// valid token was already sitting in the URL or localStorage. Deciding this
// synchronously, at store-creation time, removes that race.
const hasStoredToken =
  typeof window !== "undefined" &&
  !!(
    new URLSearchParams(window.location.search).get("token") ||
    window.localStorage.getItem("token")
  );

const initialState = {
  userInfo: {
    userId: "",
    userName: "",
    clientId: "",
    userType: "",
  },
  userList: [],
  departmentList: [],
  locationList: [],
  accessToken: [],
  isLoggedIn: hasStoredToken,
};

export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    setIsLoggedIn: (state, action) => {
      return {
        ...state,
        isLoggedIn: action.payload,
      };
    },

    setUserInfo: (state, action) => {
      return {
        ...state,
        userInfo: action.payload,
      };
    },

    setUserList: (state, action) => {
      return {
        ...state,
        userList: action.payload,
      };
    },

    setDepartmentList: (state, action) => {
      return {
        ...state,
        departmentList: action.payload,
      };
    },

    setLocationList: (state, action) => {
      return {
        ...state,
        locationList: action.payload,
      };
    },
    setAccessToken: (state, action) => {
      return {
        ...state,
        accessToken: action.payload,
      };
    },
  },
});

export const {
  setIsLoggedIn,
  setUserInfo,
  setUserList,
  setDepartmentList,
  setLocationList,
  setAccessToken,
} = authSlice.actions;

export const authReducer = authSlice.reducer;